module.exports = __webpack_public_path__ + "static/media/comscore.8e56f06b.jpg";